"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ margin: 0, fontFamily: "system-ui, sans-serif", padding: 24, background: "#f4f4f5" }}>
        <h1 style={{ fontSize: 20 }}>Application error</h1>
        <p style={{ color: "#52525b", maxWidth: 560, lineHeight: 1.5 }}>
          The root layout failed (often API unreachable from the Next server). Check{" "}
          <code>API_BASE_URL</code> / <code>NEXT_PUBLIC_API_BASE_URL</code> and Django{" "}
          <code>ALLOWED_HOSTS</code>.
        </p>
        <pre
          style={{
            marginTop: 16,
            padding: 12,
            borderRadius: 8,
            background: "#fff",
            border: "1px solid #e4e4e7",
            overflow: "auto",
            fontSize: 13,
            whiteSpace: "pre-wrap",
          }}
        >
          {error.message}
        </pre>
        <button
          type="button"
          style={{ marginTop: 20, padding: "10px 16px", fontWeight: 600, cursor: "pointer" }}
          onClick={() => reset()}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
